<div class="home-actions-component" *ngIf="filteredActions">
  <div class="overview-action" *ngFor="let actionVm of filteredActions">
    <span [innerHTML]="actionVm.label | transloco: {amount: actionVm.number, link: actionVm.link}"></span>
  </div>
</div>
